import TokenStore from './TokenStore';
import DashUserToken from './DashUserToken';


export { TokenStore, DashUserToken };

// export default class DashAuthenticatedUser {

//     constructor(config) {
//         if (!config || !config.storage) {
//             throw new Error('config.storage required');
//         }
//         this.tokenStore = new TokenStore(config.storage);
//         var token = this.tokenStore.getToken();
//         if (token) {
//             this.dashUserToken = new DashUserToken(token);
//         }
//     }

//     setToken(newToken) {
//         this.tokenStore.setToken(newToken);
//     }

// }



// WEBPACK FOOTER //
// ./src/DashAuthenticatedUser/index.js


// WEBPACK FOOTER //
// webpack:///src/DashAuthenticatedUser/index.js